(function () {
  'use strict';

  angular.module('uteAddToCalendar').controller('uteAddToCalendarController', UteAddToCalendarController);

  UteAddToCalendarController.$inject = ['$scope',
    '$timeout',
    'restive',
    '$window',
    'ute.datalayer.common.service',
    'uteLocale'];

  function UteAddToCalendarController($scope,
                                      $timeout,
                                      restive,
                                      $window,
                                      dataLayerService,
                                      uteLocale) {
    init();
    function init() {
      var isChrome, isEnglish, androidLabel;
      
      isChrome = !!$window.navigator.userAgent.match('CriOS');
      isEnglish = uteLocale.language === 'en' ? true : false;
      androidLabel = isEnglish ? 'Android Calendar' : 'Calendrier Android';
      
      $timeout(function () {
        $scope.calendarUrl = [
          {url: getGoogleCalendarUrl(), label: isEnglish ? 'Google Calendar' : 'Calendrier Google'},
          {url: getYahooCalendarUrl(), label: isEnglish ? 'Yahoo Calendar': 'Calendrier Yahoo'},
          {url: getMicrosoftCalendarUrl(), label: isEnglish ? 'Microsoft Calendar' : 'Calendrier Microsoft '}
        ];
        if (!restive.isIOS() || !isChrome) {
          $scope.calendarUrl.splice(0, 0, {url: getIcsFileUrl(), label: restive.isAndroid() ? androidLabel : 'iCalendar'});
          $scope.calendarUrl.splice(2, 0, {url: getIcsFileUrl(), label: isEnglish ? 'Outlook Calendar' : 'Calendrier Outlook'});
        }
      });
    }

    $scope.toggled = function (open) {
      if (open) {
        dataLayerService.track({}, false, [0, 1, 4], {mappingKey: 'addToCalendar.open'});
      }
    };

    $scope.openCalendar = function (calendar) {
      dataLayerService.track({
        selfServe: {
          type: 'inquiry',
          name: 'add to calendar - ' + calendar.label
        }
      }, false, [0, 1, 4], {mappingKey: 'addToCalendar.complete'});
      $window.open(calendar.url, '_blank');
    };

    function getIcsFileUrl() {
      return '/pages/api/selfserve/v1/addToCalendar/' +
        $scope.startDate +
        '/' + $scope.endDate +
        '/' + b64EncodeUnicode($scope.location) +
        '/' + b64EncodeUnicode($scope.title) +
        '/' + b64EncodeUnicode($scope.description);
    }

    function getGoogleCalendarUrl() {
      var googleCalendarUrl = 'https://www.google.com/calendar/render?action=TEMPLATE';
      googleCalendarUrl += '&text=' + $scope.title;
      googleCalendarUrl += '&dates=' + $scope.startDate + '/' + $scope.endDate;
      googleCalendarUrl += '&details=' + $scope.description;
      googleCalendarUrl += '&location=' + $scope.location;

      return encodeURI(googleCalendarUrl);
    }

    function getMicrosoftCalendarUrl() {
      var microsoftCalendarUrl = 'https://outlook.live.com/owa/?path=/calendar/action/compose&rru=addevent&allday=false';
      microsoftCalendarUrl += '&subject=' + $scope.title;
      microsoftCalendarUrl += '&startdt=' + $scope.startDate + '&enddt=' + $scope.endDate;
      microsoftCalendarUrl += '&body=' + $scope.description;
      microsoftCalendarUrl += '&location=' + $scope.location;

      return encodeURI(microsoftCalendarUrl);
    }

    function getYahooCalendarUrl() {
      var yahooCalendarUrl = 'http://calendar.yahoo.com/?v=60&view=d&type=20';
      var duration = getTimeDuration($scope.startDate, $scope.endDate);
      yahooCalendarUrl += '&TITLE=' + $scope.title;
      yahooCalendarUrl += '&ST=' + $scope.startDate + '&DUR=' + duration;
      yahooCalendarUrl += '&DESC=' + $scope.description;
      yahooCalendarUrl += '&in_loc=' + $scope.location;

      return encodeURI(yahooCalendarUrl);
    }

    function b64EncodeUnicode(str) {
      //https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding
      // first we use encodeURIComponent to get percent-encoded UTF-8,
      // then we convert the percent encodings into raw bytes which
      // can be fed into btoa.
      return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
        function toSolidBytes(match, p1) {
          return String.fromCharCode('0x' + p1);
        })
      );
    }

    function getTimeDuration(start, end) {
      var startMoment = moment(start, 'YYYYMMDDThhmmssZ');
      var endMoment = moment(end, 'YYYYMMDDThhmmssZ');
      var duration = moment.duration(endMoment.diff(startMoment));
      var minutes = duration.asMinutes();
      return pad(Math.floor(minutes / 60)).toString() + pad(minutes % 60).toString();
    }

    function pad(n) {
      return (n < 10) ? ('0' + n) : n;
    }
  }

})();
